"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _SummaryOfChargesFooter = _interopRequireDefault(require("../SummaryOfChargesFooter"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function SummaryOfChargesDueAtHotel(_ref) {
  var className = _ref.className,
      dueAtHotelAmount = _ref.dueAtHotelAmount,
      dueAtHotelTax = _ref.dueAtHotelTax,
      currencySymbol = _ref.currencySymbol,
      currencyCode = _ref.currencyCode,
      taxFootnote = _ref.taxFootnote;
  var initialProps = {
    className: className,
    title: 'Due at the hotel',
    backgroundColor: '#FFF',
    textColor: '#000'
  };
  var summaryProps = dueAtHotelAmount ? _objectSpread({}, initialProps, {
    prefixText: currencySymbol,
    suffixText: currencyCode,
    amount: dueAtHotelAmount
  }) : _objectSpread({}, initialProps, {
    title: 'Due at the hotel',
    suffixText: 'tax',
    amount: "".concat(dueAtHotelTax, "%"),
    footnoteSymbol: taxFootnote
  });
  return _react["default"].createElement(_SummaryOfChargesFooter["default"], summaryProps);
}

SummaryOfChargesDueAtHotel.displayName = 'SummaryOfChargesDueAtHotel';
SummaryOfChargesDueAtHotel.propTypes = {
  className: _propTypes["default"].string,
  dueAtHotelAmount: _propTypes["default"].number,
  dueAtHotelTax: _propTypes["default"].number,
  currencySymbol: _propTypes["default"].string,
  currencyCode: _propTypes["default"].string,
  taxFootnote: _propTypes["default"].string
};
SummaryOfChargesDueAtHotel.defaultProps = {
  className: '',
  currencySymbol: '$',
  currencyCode: 'USD'
};

var _default = (0, _react.memo)(SummaryOfChargesDueAtHotel);

exports["default"] = _default;